export default __webpack_public_path__ + "3a4ce2ca5c2828320ef9276cd18f0ee8.png";